import React, { useContext, useState, useEffect } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import InfoIcon from "../../assets/images/Info.svg";
import { AppContext } from "../../contexts/AppContext";
import { useNavigate } from "react-router-dom";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import NameChange from "../NameChange/index.js";
import GenderChange from "../GenderChange/index.js";
import FieldError from "../FieldError/index.jsx";

const ReviewCitizenship = ({ handleNext, handleBack }) => {
  const { appState, userFlows } = useContext(AppContext);

  const citizenshipData = appState.requestPayload.applicant;
  const eventData = appState.requestPayload.eventTypeSearch[0] || {};

  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const options = { day: "numeric", month: "long", year: "numeric" };
      return new Date(dateStr).toLocaleDateString("en-NZ", options); // 27 April 1948
    } catch {
      return dateStr;
    }
  };

  useEffect(() => {
    // Load passport data from localStorage if not already in state

    getLabelFromId("GenderReference", eventData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );

    getCountryNameById(citizenshipData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
  }, [eventData?.genderId, citizenshipData?.countryOfBirthId]);

  const navigate = useNavigate();

  const { handleSubmit } = useForm();

  const onSubmit = (data) => {
    if (userFlows.showPartnerStore) {
      navigate("/app/photo-id");
      return;
    }
    if (!userFlows.showLiveness) {
      navigate("/app/photo-id");
      return;
    }
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          {/* <Progress progress={40} /> */}
          <h1 className="intro-title-mi" lang="mi-NZ">
            Arotakehia ō taipitopito
          </h1>
          <hr />
          <h1 className="intro-title">Review your details</h1>

          <div style={{ marginTop: 64 }}>
            <FieldError
              info={
                "We'll verify your identity using these details. If they're incorrect, contact the <a class='cancel-link' href='https://www.govt.nz/organisations/department-of-internal-affairs/citizenship-contact-information/contact-the-citizenship-office/'>Citizenship Office.</a>"
              }
              error={null}
            />

            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode && <NameChange />}
            {appState?.requestPayload?.supportingInformation
              ?.genderSourceCode && <GenderChange />}
          </div>

          <div className="step-container">
            <h2 className="step-title mb-2">
              Your New Zealand citizenship details
            </h2>
            <div className="step-container-nospace">
              <div className="step-container-box">
                <p className="label">Given name(s)</p>
                <p className="value">
                  {citizenshipData?.namesKnownAs?.[0]?.givenNames || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Surname or family name</p>
                <p className="value">
                  {citizenshipData?.namesKnownAs?.[0]?.familyName || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Date of birth</p>
                <p className="value">
                  {formatDate(citizenshipData?.dateOfBirth) || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Citizenship certificate number</p>
                <p className="value">{eventData?.documentNumber || "-"}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Place of birth (town/city)</p>
                <p className="value">
                  {citizenshipData?.placeOfBirth?.trim()
                    ? citizenshipData.placeOfBirth
                    : "Unknown"}
                  </p>
              </div>
              <div className="step-container-box">
                <p className="label">Country of birth</p>
                <p className="value">{addressCountryLabel || "-"}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Gender</p>
                <p className="value">{genderLabel || "-"}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="step-button-container">
          <SubmitButton text={"Confirm"} type="submit" />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default ReviewCitizenship;
